import translations from './translations'

translations.add('is', {
    headerMessage: 'Ertu viss um að þú viljir hætta við?',
    no: 'NEI',
    yes: 'JÁ'
})
